import { calculateTimeRemaining, calculateTokenExpiry, isTokenExpired, isTokenValid } from '@/shared/lib/auth'
import { authPersistence } from '@/shared/lib/storage'

export function isAuthenticated(): boolean {
  try {
    const state = authPersistence.getState()
    return isTokenValid(state.token) && !isTokenExpired(state.tokenExpiry)
  } catch (error) {
    console.error('Error checking authentication:', error)
    return false
  }
}

/**
 * Gets the remaining time in milliseconds until token expiration
 * Useful for scheduling token refresh before expiration
 *
 * @returns number - seconds until expiration, or 0 if expired/invalid
 */
export function getTokenExpiryTimeRemaining(): number {
  try {
    const state = authPersistence.getState()

    if (!state?.token || !state?.tokenExpiry) {
      return 0
    }

    return calculateTimeRemaining(state.tokenExpiry)
  } catch {
    console.error('Error getting token expiry time')
    return 0
  }
}

/**
 * Sets a token with a 3-month expiry period
 * This function should be called when setting a new auth token
 *
 * @param token The authentication token to store
 */
export function setTokenWithExpiry(token: string): void {
  try {
    if (!token) {
      console.warn('Attempted to set empty token')
      return
    }

    authPersistence.setState({
      ...authPersistence.getState(),
      token,
      tokenExpiry: calculateTokenExpiry(),
    })
  } catch (error) {
    console.error('Error setting token with expiry:', error)
  }
}
